<div class="response-status-badge">
  <button
    type="button"
    class="response-status-badge-trigger"
    [class.response-status-badge-trigger--open]="dropdownOpen"
    [class.response-status-badge-trigger--closed]="closed"
    (click)="toggle()"
  >
    @if (closed) {
      <i class="ph ph-check response-status-badge-trigger-icon response-status-badge-trigger-icon--closed" aria-hidden="true"></i>
    } @else {
      <span class="response-status-badge-dot" aria-hidden="true"></span>
    }
    <span class="response-status-badge-label">
      {{ (closed ? 'tenders.responses.status-badge.closed' : 'tenders.responses.status-badge.active') | translate }}
    </span>
    <i class="ph ph-caret-down response-status-badge-caret" aria-hidden="true"></i>
  </button>

  @if (dropdownOpen) {
    <div class="response-status-badge-backdrop" (click)="closeDropdown()"></div>
    <div class="response-status-badge-dropdown">
      <button
        type="button"
        class="response-status-badge-option"
        [class.response-status-badge-option--active]="!closed"
        (click)="select(false)"
      >
        <span class="response-status-badge-dot" aria-hidden="true"></span>
        {{ 'tenders.responses.status-badge.active' | translate }}
        @if (!closed) {
          <i class="ph ph-check response-status-badge-option-check" aria-hidden="true"></i>
        }
      </button>
      <button
        type="button"
        class="response-status-badge-option"
        [class.response-status-badge-option--active]="closed"
        (click)="select(true)"
      >
        <i class="ph ph-check response-status-badge-trigger-icon--closed" aria-hidden="true"></i>
        {{ 'tenders.responses.status-badge.closed' | translate }}
        @if (closed) {
          <i class="ph ph-check response-status-badge-option-check" aria-hidden="true"></i>
        }
      </button>
    </div>
  }
</div>
